import { apiCreate } from './ApiBaseActions';
export const POPUP_RFP_REPLACE_HIDE_ACTION = 'POPUP_RFP_REPLACE_HIDE_ACTION';
export const API_CREATE_POPUP_READ = 'API_CREATE_POPUP_READ';
export const popupRfpReplaceHideAction = () => ({
    type: POPUP_RFP_REPLACE_HIDE_ACTION,
});
export const apiCreatePopupRead = (event, meta) => apiCreate(API_CREATE_POPUP_READ, `/popup/${event}`, {}, Object.assign(Object.assign({}, (meta || {})), { event }));
